import { children, id } from "./power";
import { deleteNull } from "@src/utils";
const power = {
    ...children,
    ...{ [id.id]: id }
};

export default class TaxRateApi {
    /**
     * 获取税率维护
     *
     * @param {any} params
     * @returns
     *
     * @memberOf TaxRateApi
     */
    [power[id.id].apiName](params) {
        let url = power[id.id].url;
        return this.POST(url, params);
    }

    [children.SAVE_DATA.apiName](params) {
        let url = children.SAVE_DATA.url;
        return this.POST(url, params);
    }
}
